import axios from '@/libs/api.request'
import config from '@/config'

const privateCloudBaseUrl = config.basePrivateCloudUrl + '/cloud/api/v1/'

export const getPrivateCloudAvailabilityZones = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'availability_zone_list/',
    params: params,
    method: 'get'
  })
}

export const getPrivateCloudAvailabilityZonesDetailList = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'availability_zone_list/list_detail/',
    params: params,
    method: 'get'
  })
}
